export const isFileuploadServiceURL = (url: string) =>
  url.includes("fileupload-service");

export const isGoogleDriveURL = (url: string) =>
  url.includes("https://drive.google.com");
